<template lang="pug">
	div(style="overflow-y: auto;")
		b-table(striped hover :items="_items" :fields="filteredFields")
			template(v-slot:cell(index)="data") {{ data.index + 1 }}
			template(v-slot:cell(user)="data")
				span(v-if="data.item.user")
					| {{ data.value.first_name }} {{ data.value.last_name }} {{ data.value.patronymic }}
					|
					span(v-if="data.item.id === _ppnt.data.id") (Вы)
				span(v-else)
					| {{ data.item.dependent_member.first_name }} {{ data.item.dependent_member.last_name }} {{ data.item.dependent_member.patronymic }}
			template(v-slot:cell(session_approved)="data")
				| {{ data.value ? 'да' : 'нет' }}
			template(v-slot:cell(reg_extra_data)="data")

				div(v-for="(cat, key) in _ppnt.data.event.extra_data_category || []" v-if="check(cat)" :key="key")
					h6 {{ cat.title }}
					div.d-flex.mb-2(style="margin:-2px;")
						span.badge.badge-primary(v-for="(data,key) in data.value.filter(item=> item.extra_data_type.category === cat.id)" :key="key" style="margin:2px;")
							| {{ data.extra_data_type.title }}


			template(v-slot:cell(price)="data") {{ data.value }} ₽
		div(v-if="_ppnt.data.use_price")
			h5 Итог: {{ _ppnt.data.team_calculate_price }} ₽

</template>

<script>
	export default {
		name: 'groupTable',
		props:['_items','_fields', '_ppnt'],
		data: () => ({}),
		methods: {
			check(cat){ return this._ppnt.data.reg_extra_data.filter(item=> item.extra_data_type.category === cat.id).length }
		},
		computed: {
			filteredFields(){
				return this._fields.reduce( (acc,item) => {
					return ( !this._ppnt.data.event.use_price && item === 'price' )
						|| ( !this._ppnt.data.event.can_add_session && item.key === "session_approved" )
						|| ( !this._ppnt.data.reg_extra_data.length && item.key === "reg_extra_data" )
							? [...acc]
							: [...acc, item];
				}, []);
			}
		},
	}
</script>
